import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const BaseTab = styled.button<{active: boolean}>`
  color: #ffffff;
  padding: 10px 20px;
  font-weight: 600;
  border-left: 2px solid #ffffff;
  border-right: none;
  border-top: none;
  border-bottom: none;
`

export const FreshTab = styled(BaseTab)`
  background-color: ${(props) => (props.active ? '#376a07' : '#79b93e')};
`

export const Tab = styled(BaseTab)`
  background-color: ${(props) => (props.active ? '#002962' : '#5C81B9')};
`
